import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Headers, Http} from '@angular/http';
import {Router} from '@angular/router';

@Injectable()
export class BoxStampDistributionService {
  headers: Headers;
  url = environment.qrcode_url;
  url_aps = environment.qrcode_url_aps;

  constructor(private http: Http, private router: Router) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }
  editProductRoadmap(code,body): Observable<any> {
    return this.http
      .put(`${this.url}/distributor/history/v2/${code}`, body, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        if (error.json() && error.json().status === 403) {
          localStorage.removeItem('Access-Token');
          localStorage.removeItem('Access-Token-Icheck');
          this.router.navigate(['/login']);
        }
        throw error.json();
      });
  }
  transferStamp(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer_stamp`, body, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        if (error.json() && error.json().status === 403) {
          localStorage.removeItem('Access-Token');
          localStorage.removeItem('Access-Token-Icheck');
          this.router.navigate(['/login']);
        }
        throw error.json();
      });
  }

  transferValidate(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/validate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // tuanBa:10-3-2023 : Validate màn phân phối tem SP và tem thùng
  transferValidateNew(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/mobile/scan/validate/stamp`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  detailAgencies(id): Observable<any> {
    return this.http
      .get(`${this.url}/agencies/${id}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  detailStamp(id): Observable<any> {
    return this.http
      .get(`${this.url}/mobile/scan/decode?code=${id}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  uploadFileCustomer(file?: any, query?: any): Observable<any> {
    this.headers.delete('Content-Type');
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    const lang = localStorage.getItem('lang') || 'vi';
    this.headers.set('Accept-Language', lang);
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http
      .post(`${this.url}/transfer_stamp/import?requiredAccept=${query.requiredAccept}&routing=${query.routing}`, formData, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  /**
   *  Gán chương trình sell-out /loyalty
   */

  /** Danh sách chương tình sell-out */
  getListCampaignSellout(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/sale_out/campaigns?systemType=${0}`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  getDetailCodeSellout(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/sale_out/campaigns/code?systemType=${0}`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  validateCampaignsSellout(body?: any): Observable<any> {
    return this.http
      .post(`${this.url_aps}/distribution/campaigns/validate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  /**----------------------------------*/
  getListCampaignLoyalty(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/loyalty/campaigns`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  getDetailCodeLoyalty(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/loyalty/campaigns/code?systemType=${1}`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  /** Phan phoi */
  distribution(body?: any): Observable<any> {
    return this.http
      .post(`${this.url_aps}/distribution/campaigns`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  /**[2-11-2022]: Tuanba: check prefix **/
  getPrefix(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/prefix`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  getTypeSettingDistribute(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/transfer/setting`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/boxStampDistribution/services/boxStampDistribution.service.ts